import { useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import AddButton from '../../../componente/cadastro/botaoadd/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { usePermissoes } from "../../../componente/permissoes";

Modal.setAppElement("#root");

const CadEmpresa = () => {
    const { podeInserir, podeEditar, podeExcluir } = usePermissoes();

    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showform, setshowform] = useState(false);
    const { accessKey, codassinante } = useAppContext(); // Acessa os dados do contexto          
    const [novo, setnovo] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const columns = [
        { key: 'codempresa', title: 'Código' },
        { key: 'razaosocial', title: 'Razão Social' },
        { key: 'nomefantasia', title: 'Nome Fantasia' },
        { key: 'cnpj', title: 'CNPJ' },
        { key: 'cidade', title: 'Cidade' },
        { key: 'bairro', title: 'Bairro' },
    ];

    //campos
    const [codEmpresa, setCodEmpresa] = useState(0);
    const [razaoSocial, setRazaoSocial] = useState("");
    const [nomeFantasia, setNomeFantasia] = useState("");
    const [cnpj, setCNPJ] = useState("");
    const [ie, setIE] = useState("");
    const [cep, setCEP] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [uf, setUF] = useState("");
    const [codCidade, setCodCidade] = useState("");
    const [pais, setPais] = useState("");
    const [codPais, setCodPais] = useState("");
    const [crt, setCRT] = useState(0);
    const [telefone, setTelefone] = useState("");
    const [whatsapp, setWhatsApp] = useState("");
    const [email, setEmail] = useState("");


    const handleOpen = (cad) => {
        setCodEmpresa(cad.codempresa);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        handleDelete();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const fetchData = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/empresa", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

        // Cleanup function para limpar o timeout anterior
        return () => clearTimeout(timeoutId);
    }, [search, currentPage, perPage]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1); // Volta para primeira página ao mudar quantidade
    };

    const handleEdit = async (user) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/empresaum", {
                params: {
                    codempresa: user.codempresa
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowform(true);
            setnovo(false);

            setCodEmpresa(user.codempresa);
            setRazaoSocial(response.data.razaosocial);
            setNomeFantasia(response.data.nomefantasia);
            setCNPJ(response.data.cnpj);
            setIE(response.data.ie);
            setCEP(response.data.cep);
            setEndereco(response.data.endereco);
            setNumero(response.data.numero);
            setComplemento(response.data.complemento);
            setBairro(response.data.bairro);
            setCidade(response.data.cidade);
            setUF(response.data.uf);
            setCodCidade(response.data.codcidade);
            setPais(response.data.pais);
            setCodPais(response.data.codpais);
            setCRT(response.data.crt);
            setTelefone(response.data.telefone);
            setWhatsApp(response.data.whatsapp);
            setEmail(response.data.email);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await api.delete("v1/cad/empresa", {
                params: {
                    codempresa: codEmpresa,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setshowform(true);
        setnovo(true);

        setCodEmpresa(0);
        setRazaoSocial('');
        setNomeFantasia('');
        setCNPJ('');
        setIE('');
        setCEP('');
        setEndereco('');
        setNumero('');
        setComplemento('');
        setBairro('');
        setCidade('');
        setUF('');
        setCodCidade('');
        setPais('');
        setCodPais('');
        setCRT(0);
        setTelefone('');
        setWhatsApp('');
        setEmail('');
    };

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    async function Editar() {
        try {
            setLoading(true);
            setError(null);
            await api.put("v1/cad/empresa", {
                codempresa: codEmpresa,
                razaosocial: razaoSocial,
                nomefantasia: nomeFantasia,
                cnpj,
                ie,
                cep,
                endereco,
                numero,
                complemento,
                bairro,
                cidade,
                uf,
                codcidade: codCidade,
                pais,
                codpais: codPais,
                crt,
                telefone,
                whatsapp,
                email,
            }, {
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function Cadastrar() {
        try {
            setLoading(true);
            setError(null);
            await api.post("v1/cad/empresa", {
                razaosocial: razaoSocial,
                nomefantasia: nomeFantasia,
                cnpj,
                ie,
                cep,
                endereco,
                numero,
                complemento,
                bairro,
                cidade,
                uf,
                codcidade: codCidade,
                pais,
                codpais: codPais,
                crt,
                telefone,
                whatsapp,
                email,
                excluido: 'N',
                codassinante
            }, {
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">
                    <PopUp isOpen={isOpen} onClose={handleClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse registro?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp>

                    <Modal
                        isOpen={showform}
                        onRequestClose={() => setshowform(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowform(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="razaosocial"
                                                    id="razaosocial"
                                                    value={razaoSocial}
                                                    onChange={(e) => setRazaoSocial(e.target.value)}
                                                />
                                                <label htmlFor="razaosocial">Razão Social</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="nomefantasia"
                                                    id="nomefantasia"
                                                    value={nomeFantasia}
                                                    onChange={(e) => setNomeFantasia(e.target.value)}
                                                />
                                                <label htmlFor="nomefantasia">Nome Fantasia</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cnpj"
                                                    id="cnpj"
                                                    value={cnpj}
                                                    onChange={(e) => setCNPJ(e.target.value)}
                                                />
                                                <label htmlFor="cnpj">CNPJ</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="ie"
                                                    id="ie"
                                                    value={ie}
                                                    onChange={(e) => setIE(e.target.value)}
                                                />
                                                <label htmlFor="ie">Ins. Estadual</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cep"
                                                    id="cep"
                                                    value={cep}
                                                    onChange={(e) => setCEP(e.target.value)}
                                                />
                                                <label htmlFor="cep">CEP</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="endereco"
                                                    id="endereco"
                                                    value={endereco}
                                                    onChange={(e) => setEndereco(e.target.value)}
                                                />
                                                <label htmlFor="endereco">Endereço</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-1 col-lg-1 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="numero"
                                                    id="numero"
                                                    value={numero}
                                                    onChange={(e) => setNumero(e.target.value)}
                                                />
                                                <label htmlFor="numero">Núm.</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="complemento"
                                                    id="complemento"
                                                    value={complemento}
                                                    onChange={(e) => setComplemento(e.target.value)}
                                                />
                                                <label htmlFor="complemento">Complemento</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="bairro"
                                                    id="bairro"
                                                    value={bairro}
                                                    onChange={(e) => setBairro(e.target.value)}
                                                />
                                                <label htmlFor="bairro">Bairro</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cidade"
                                                    id="cidade"
                                                    value={cidade}
                                                    onChange={(e) => setCidade(e.target.value)}
                                                />
                                                <label htmlFor="cidade">Cidade</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-1 col-lg-1 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="uf"
                                                    id="uf"
                                                    value={uf}
                                                    onChange={(e) => setUF(e.target.value)}
                                                />
                                                <label htmlFor="uf">UF</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="codcidade"
                                                    id="codcidade"
                                                    value={codCidade}
                                                    onChange={(e) => setCodCidade(e.target.value)}
                                                />
                                                <label htmlFor="codcidade">Cód. IBGE Cida.</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="pais"
                                                    id="pais"
                                                    value={pais}
                                                    onChange={(e) => setPais(e.target.value)}
                                                />
                                                <label htmlFor="pais">País</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="codpais"
                                                    id="codpais"
                                                    value={codPais}
                                                    onChange={(e) => setCodPais(e.target.value)}
                                                />
                                                <label htmlFor="codpais">Cód. IBGE País</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <select
                                                    className="form-select"
                                                    id="crt"
                                                    value={crt}
                                                    onChange={(e) => setCRT(e.target.value)}
                                                >
                                                    <option value="0">SIMPLES NACIONAL</option>
                                                    <option value="1">SIMPLES EXCESSO RECEITA</option>
                                                    <option value="2">REGIME NORMAL</option>
                                                </select>
                                                <label htmlFor="crt">CRT</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="telefone"
                                                    id="telefone"
                                                    value={telefone}
                                                    onChange={(e) => setTelefone(e.target.value)}
                                                />
                                                <label htmlFor="telefone">Telefone</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="whatsapp"
                                                    id="whatsapp"
                                                    value={whatsapp}
                                                    onChange={(e) => setWhatsApp(e.target.value)}
                                                />
                                                <label htmlFor="whatsapp">WhatsApp</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="email"
                                                    id="email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                                <label htmlFor="email">E-mail</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowform(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={Salvar}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </Modal>

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Cadastro de Empresa" icon="shop" />
                        <Description text="Cadastro das empresas ou filiais" />

                        <div className="row mb-3">
                            <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar empresas por: Código, Razão Social, Nome Fantasia ou CNPJ"
                                />
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 text-center">
                                <AddButton onClick={handleAdd} text="Nova Empresa" disabled={!podeInserir("/cad/empresa")}/>
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        onEdit={handleEdit}
                                        isEditDisabled={() => !podeEditar("/cad/empresa")}
                                        onDelete={handleOpen}
                                        isDeleteDisabled={() => !podeExcluir("/cad/empresa")}
                                    />
                                </div>
                            )}
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />
                    </div>
                </main>
            </div>
        </>
    );
};

export default CadEmpresa;